/**
 * Knowledge Base — one of the six offerings on sentrodesk.com/pricing.
 *
 * The editor itself lives inside Settings → Chatbot. Rather than duplicate that
 * state here, this page owns the plan gate and hands an entitled tenant
 * straight to the section, so the feature has one obvious place to click.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import FeatureLocked from "@/components/feature/FeatureLocked";
import { useEntitlements } from "@/contexts/EntitlementsContext";

export default function KnowledgeBasePage() {
  const { hasFeature, loading } = useEntitlements();
  const navigate = useNavigate();
  const entitled = hasFeature("knowledge_base");

  useEffect(() => {
    if (!loading && entitled) navigate("/settings?section=bot", { replace: true });
  }, [loading, entitled, navigate]);

  // A bare `null` while entitlements load reads as a dead click, so hold the
  // frame instead of blanking the screen.
  if (loading) {
    return (
      <AppLayout>
        <div className="flex min-h-[60vh] items-center justify-center text-sm text-slate-400">
          Loading…
        </div>
      </AppLayout>
    );
  }

  if (entitled) return null;

  return (
    <AppLayout>
      <FeatureLocked feature="knowledge_base" />
    </AppLayout>
  );
}
